import styled from '@emotion/styled';

import { customPalette } from '../../styles/theme';

export const PageWrapper = styled.div`
  padding: 24px;
  background-color: ${customPalette.accent.white};
  border-radius: 16px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: ${customPalette.grey.main};
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

export const TableHeader = styled.th`
  padding: 16px;
  text-align: left;
  background-color: ${customPalette.grey[200]};
  color: ${customPalette.grey.main};
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  min-width: 120px;

  &:first-of-type {
    padding-left: 24px;
  }

  &:last-of-type {
    padding-right: 24px;
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${customPalette.grey[200]};

  &:last-child {
    border-bottom: none;
  }

  &:nth-of-type(odd) {
    background-color: ${customPalette.accent.white};
  }

  &:nth-of-type(even) {
    background-color: ${customPalette.grey[0]};
  }
`;

export const TableCell = styled.td`
  padding: 16px;
  color: ${customPalette.grey.main};
  font-size: 14px;
  border-bottom: 1px solid ${customPalette.grey[200]};

  &:first-of-type {
    padding-left: 24px;
  }

  &:last-of-type {
    padding-right: 24px;
  }
`;

export const CellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: ${customPalette.grey.main};
  font-size: 12px;

  &:hover {
    color: green;
  }
`;

export const EditInput = styled.input`
  padding: 8px;
  border: 1px solid ${customPalette.grey[200]};
  border-radius: 4px;
  margin-right: 8px;
  font-size: 14px;
  width: 100%;
  max-width: 200px;
`;

export const PhotoCell = styled(TableCell)``;

export const PhotoCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PhotoContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${customPalette.grey[100]};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  span {
    font-size: 12px;
    color: ${customPalette.grey[400]};
  }
`;

export const UploadButton = styled(ActionButton)`
  text-decoration: underline;

  &:hover {
    color: green;
  }
`;

export const SearchSection = styled.div`
  margin-bottom: 20px;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SearchLabel = styled.label`
  font-weight: 600;
`;

export const SearchInput = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const SearchButton = styled.button`
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;
